(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schoolsmart-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const timers = document.querySelectorAll('[data-ss-halloween-countdown]');
    timers.forEach((timer) => {
      if (timer.dataset.timerStarted === 'true') return;
      timer.dataset.timerStarted = 'true';
      const target = new Date(timer.dataset.target).getTime();
      const values = {
        days: timer.querySelector('[data-days]'),
        hours: timer.querySelector('[data-hours]'),
        minutes: timer.querySelector('[data-minutes]'),
        seconds: timer.querySelector('[data-seconds]')
      };
      const update = () => {
        const remaining = Math.max(0, target - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        values.days.textContent = String(Math.floor(totalSeconds / 86400));
        values.hours.textContent = String(Math.floor(totalSeconds % 86400 / 3600)).padStart(2, '0');
        values.minutes.textContent = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
        values.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
        if (remaining === 0) {
          const title = timer.querySelector('[data-countdown-title]');
          if (title && timer.dataset.expired) title.textContent = timer.dataset.expired;
        }
      };
      update();
      window.setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
